import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import { set, get, del } from 'idb-keyval'
import {errorHandler} from "@/services/errorHandler";
import router from "@/router";
import timeModule from "@/store/modules/time-module";
import versionModule from "@/store/modules/version-module";
import logs from "@/store/modules/logs";
import externalVersion from "@/store/modules/external-version";

Vue.use(Vuex);
const indexedDBStorage = {
    getItem: async (key) => {
        const value = await get(key);
        console.log('Getting from IndexedDB:', { key, value });
        return value;
    },
    setItem: async (key, value) => {
        console.log('Saving to IndexedDB:', { key, value });
        await set(key, value);
    },
    removeItem: async (key) => {
        console.log('Removing from IndexedDB:', key);
        await del(key);
    }
};
const vuexLocal = new VuexPersistence({
    storage: indexedDBStorage, // Use localStorage as fallback
    asyncStorage: true, // Enable async storage handling
    restoreState: async (key) => {
        try {
            const value = await get(key);
            console.log('Restoring state from IndexedDB:', { key, value });
            if (value) {
                value.isHydrated = true;
                return value;
            }
            return { isHydrated: true };
        } catch (err) {
            console.error('Error restoring state:', err);
            return {};
        }
    },
    saveState: async (key, value) => {
        try {
            console.log('Saving state to IndexedDB:', { key, value });
            await set(key, value);
        } catch (err) {
            console.error('Error saving state:', err);
        }
    },
});
const store = new Vuex.Store({
    state: {
        currentUser : null,
        loading : false,
        isUpdateAvailable : false,
        isHydrated : false,
        sessionID : null,
        developers : [],
        attemptedLoginRoute : { name : `Dashboard` }
    },
    getters: {
        getDevelopers: (state) => state.developers,
        getUpdateAvailability: (state) => state.isUpdateAvailable,
        isHydrated: (state) => state.isHydrated,
        getCurrentUser: (state) => state.currentUser,
        getLoadingState: (state) => state.loading,
        getSessionID: (state) => state.sessionID,
        getAttemptedRoute: (state) => state.attemptedLoginRoute,
        isManager:(state) => {
            let user = state.currentUser;
            if (!user || !user.deptInfo) return false;
            let manager = state.currentUser.deptInfo.managerId;
            return (user.id === manager) || user.Type === `Super_User`;
        }
    },
    mutations: {
        setUpdateAvailability: (state,data) => state.isUpdateAvailable = data,
        setCurrentUser: (state , data) => state.currentUser = data,
        setLoadingState: (state , data) => state.loading = data,
        setSessionID: (state , data) => state.sessionID = data,
        setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
        setDevelopers: (state, data) => state.developers = data,
    },
    actions: {
        getDevelopers :async (context) => {
            return axios.get(synergyApi+`employee/getEmployeesByDepartment?Type=Developer`)
                .then(({data})=>context.commit(`setDevelopers`,data.map(dev=>dev.Username)))
                .catch(err=>errorHandler.tomcatError(err))
        },
        triggerResetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${synergyApi}employee/resetPassword`,
                payload:{
                    email: payload
                },
            })
        },
        resetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${synergyApi}employee/processResetPassword`,
                payload,
            })
        },
        userLogin: async (context, payload) => {
            return axios.post(ticketApi + `user/Login`, payload)
                .then(({data}) => context.commit('setCurrentUser', data))
                .catch(err => errorHandler.tomcatError(err))
        },
        verifyOtp: (context, payload) => {
            console.log(payload)
            return axios.post(ticketApi + 'user/verifyOtp', payload)
                .then(({data}) => {
                    context.commit(`setSessionID`,data)
                    let route = context.getters.getAttemptedRoute;
                    let routeName = route.name;
                    console.log({routeName})
                    const resolvedRoute = router.resolve({ name: routeName });
                    let exists = resolvedRoute.route.name === routeName;
                    if(!exists) route = { name : `Dashboard` };
                    return router.push(route);
                }).catch(err => errorHandler.tomcatError(err));
        },
        sendRequest(context, {url, payload, headers = {}, method = 'post'}) {
            const maxRetries = 3;
            let currentRetry = 0;
            if (!payload.localid){
                payload.localid = generateUUID();
            }

            const attemptRequest = () => {
                return axios[method](url, payload, {
                    headers: headers || {}
                }).then(({data}) => {
                    if (!data.processed) {
                        // Check if the response indicates unprocessed data and if retries are available
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                        // Throw an error if max retries are reached with unprocessed data
                        throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
                    }
                    payload.localid = null;
                    return data.response; // Return the response if data is processed
                }).catch(err => {
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                    }
                    throw err; // Re-throw the error if it's not a timeout or retries are exhausted
                });
            };
            return attemptRequest()
                .then(response => response)
                .catch(err => errorHandler.tomcatError(err));
        }
    },
    modules: { timeModule , versionModule , logs, externalVersion },
    plugins: [
        vuexLocal.plugin,
    ]
});
export default store;

